import './App.css';
import { useState } from 'react';
import { Task } from './Task';

function App() {
  const [todo,setTodo] = useState([]);
  const [newTask,setNewTask] = useState("");

  const handleChange=(event)=>{
      setNewTask(event.target.value)
  }
  const addTask=()=>{
    const task ={
      id: todo.length === 0 ? 1 : todo[todo.length-1].id +1,
      taskName: newTask,
      completed:false,
    }
    setTodo(task.taskName !== "" ? [...todo,task] : todo);
    setNewTask("")
  }
const deleteTask =(id)=>{
  setTodo(todo.filter((task)=> task.id!==id));
  // setTodo(newTodoList);
}


const completeTask = (id) => {
  setTodo(
    todo.map((task) => {
      if (task.id === id) {
        return { ...task, completed: true };
      } else {
        return task;
      }
    })
  );
};

  return (
    <div className="App">
      <div className='addTask'>
        <input className='input' onChange={handleChange} value={newTask}/>
        <button className='buttonadd' onClick={addTask}>Add Task</button>
      </div>
      <div className='list'>
        {
          todo.map((task)=>{
            return(
            <Task
            taskName={task.taskName}
            id={task.id}
            completed={task.completed}
            completeTask={completeTask}
            deleteTask={deleteTask} 
             />
            );
          })
        }
      </div>
    </div>
  );
}

export default App;
